import { SEO } from "@/components/SEO";
import { HomeHero }         from "../components/site/home/HomeHero";
import { Tension }          from "../components/site/home/Tension";
import { Method }           from "../components/site/home/Method";
import { WaysToWork }       from "../components/site/home/WaysToWork";
import { GratitudeRoom }    from "../components/site/home/GratitudeRoom";
import { Books }            from "../components/site/home/Books";
import { HomeTestimonials } from "../components/site/home/HomeTestimonials";
import { HomeFinalCTA }     from "../components/site/home/HomeFinalCTA";

export default function Home() {
  return (
    <div data-testid="home-page">
      <SEO
        title="Life Coaching, Books & Spark Sessions"
        description="Blueprint4Joy® helps you build a life around what actually makes you happy — through coaching, Spark Sessions, speaking, and books by Lara Parrish."
        path="/"
      />
      <HomeHero />
      <Tension />
      <Method />
      <WaysToWork />
      <GratitudeRoom />
      <Books />
      <HomeTestimonials />
      <HomeFinalCTA />
    </div>
  );
}
